<div class="container">
  <mat-toolbar>
    <span>
      <h3> Account Management </h3>
    </span>
  </mat-toolbar>

  <iframe [src]="urlSafe" class="iframe"></iframe> 

</div>